<template>
    <div style="height: 100%" v-if="groupedAccountingLines">
        <template v-if="!inbeddedMode && !$vuetify.display.mobile">
            <v-row no-gutters>
                <v-col cols="12" class="d-flex flex-row pa-2">
                    <div class="mr-2">
                        <v-btn-back @click.stop="back()" v-if="mode != 'GeneralLedger'">
                        </v-btn-back>
                    </div>
                    <div>
                        <h1>{{ title }}</h1>
                    </div>
                    <div>
                        <v-btn-icon
                            @click.stop="help()"
                            class="ml-3"
                            size="small"
                            icon="$fa-question"
                        >
                        </v-btn-icon>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-window v-model="wizardStep" touchless>
                        <v-window-item :value="0">
                            <v-container fluid>
                                <v-row>
                                    <v-col>
                                        <v-data-table
                                            :headers="groupItemsHeaders2"
                                            :items="groupedAccountingLines"
                                            hide-default-footer
                                            :items-per-page="-1"
                                            class="table"
                                            fixed-header
                                            max-height="60vh"
                                            :loading="loading"
                                            style="width: 100%"
                                            xs12
                                        >
                                            <template v-slot:item="{ item, index }">
                                                <!-- <td v-for="(header) in reconciliationItems">{{ item[header.value] }}</td> -->
                                                <tr
                                                    :style="
                                                        alIndex === 0
                                                            ? 'cursor: pointer; border-top;font-weight: bold;'
                                                            : 'cursor: pointer'
                                                    "
                                                    v-for="(accountingItem, alIndex) in item.items"
                                                    :key="index + '-' + alIndex"
                                                    @click.stop="
                                                        addRemoveReconciliationExpend(
                                                            accountingItem,
                                                        )
                                                    "
                                                >
                                                    <td
                                                        class="text-center"
                                                        :style="getCellStyle(alIndex, false)"
                                                    >
                                                        <v-icon :small="true" class="mr-2">{{
                                                            formatIconName(accountingItem.iconType)
                                                        }}</v-icon>
                                                    </td>
                                                    <!-- <td class="text-xs-left">{{ accountingItem.type }}</td> -->
                                                    <td
                                                        class="text-left"
                                                        :style="getCellStyle(alIndex, false)"
                                                    >
                                                        <div>
                                                            <v-chip
                                                                label
                                                                color="grey"
                                                                class="mr-2"
                                                                v-if="
                                                                    (accountingItem.bt &&
                                                                        accountingItem.bt
                                                                            .accountingItemImport) ||
                                                                    (accountingItem.doc &&
                                                                        accountingItem.doc
                                                                            .accountingItemImport)
                                                                "
                                                                size="small"
                                                                variant="outlined"
                                                                >Importé</v-chip
                                                            >{{ accountingItem.name }}
                                                        </div>
                                                        <div v-if="accountingItem.bt">
                                                            <span v-if="accountingItem.suppliers"
                                                                >Fournisseur:
                                                                {{ accountingItem.suppliers }}</span
                                                            >
                                                            <span v-if="accountingItem.customers"
                                                                >Client:
                                                                {{ accountingItem.customers }}</span
                                                            >
                                                            <span v-if="accountingItem.user"
                                                                >Collaborateur :
                                                                {{ accountingItem.user }}</span
                                                            >
                                                            <span v-if="accountingItem.bankAccount"
                                                                >Compte bancaire :
                                                                {{
                                                                    accountingItem.bankAccount
                                                                }}</span
                                                            >
                                                        </div>
                                                        <FreeTag
                                                            :companyTags="allCompanyTags"
                                                            :company="selectedCompany"
                                                            :documentType="'BANK_TRANSACTION'"
                                                            :accountingLine="
                                                                accountingItem.accountingLine
                                                            "
                                                            v-if="
                                                                accountingItem.accountingLine.id &&
                                                                accountingItem.accountingLine
                                                                    .bankTransaction
                                                            "
                                                        />
                                                        <div v-if="accountingItem.doc">
                                                            <!-- <v-chip  size=“x-small” label :ripple="false" v-if="accountingItem.doc.status.startsWith('ANALYSED')">
                                                                <span :style="'color:orange;'">A valider</span>
                                                            </v-chip> -->
                                                            <span
                                                                v-if="
                                                                    accountingItem.doc.type ===
                                                                    'WITHOUT_INVOICE'
                                                                "
                                                                >Sans justificatif</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    accountingItem.doc.type ===
                                                                    'SALES_INVOICE_AUTO'
                                                                "
                                                                >Encaissemment</span
                                                            >
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="text-center"
                                                        :style="getCellStyle(alIndex, false)"
                                                    >
                                                        {{ accountingItem.date }}
                                                    </td>
                                                    <td
                                                        class="text-right"
                                                        :style="getCellStyle(alIndex, false)"
                                                    >
                                                        <span
                                                            v-if="isMainItem(item, accountingItem)"
                                                            >{{
                                                                accountingItem.debit
                                                                    ? newCommonFormatCurrency(
                                                                          accountingItem.debit,
                                                                      )
                                                                    : "-"
                                                            }}</span
                                                        >
                                                    </td>
                                                    <td
                                                        class="text-right"
                                                        :style="getCellStyle(alIndex, false)"
                                                    >
                                                        <span
                                                            v-if="isMainItem(item, accountingItem)"
                                                            >{{
                                                                accountingItem.credit
                                                                    ? newCommonFormatCurrency(
                                                                          accountingItem.credit,
                                                                      )
                                                                    : "-"
                                                            }}</span
                                                        >
                                                    </td>
                                                    <td
                                                        class="text-center"
                                                        :style="getCellStyle(alIndex, false)"
                                                        v-if="isAccountingUser"
                                                    >
                                                        <span
                                                            :style="
                                                                getIfNecessaryAccountableAccountColor(
                                                                    item,
                                                                    alIndex,
                                                                )
                                                            "
                                                            >{{
                                                                getIfNecessaryAccountableAccount(
                                                                    item,
                                                                    alIndex,
                                                                )
                                                            }}</span
                                                        >
                                                    </td>
                                                    <td
                                                        class="text-center"
                                                        :style="getCellStyle(alIndex, false)"
                                                    >
                                                        <v-chip
                                                            class="ma-2 font-weight-regular"
                                                            label
                                                            v-if="
                                                                alIndex === 0 &&
                                                                groupStatusWithoutAA(item)
                                                            "
                                                            size="small"
                                                            variant="outlined"
                                                            >{{
                                                                groupStatusWithoutAA(item)
                                                            }}</v-chip
                                                        >
                                                    </td>
                                                    <td
                                                        class="text-center"
                                                        :style="getCellStyle(alIndex, true)"
                                                        v-if="isAccountingUser"
                                                    >
                                                        <v-list
                                                            rounded
                                                            class="ma-2"
                                                            density="compact"
                                                        >
                                                            <v-menu
                                                                offset-y
                                                                :activator="
                                                                    '#more-actions-' +
                                                                    index +
                                                                    '-' +
                                                                    alIndex
                                                                "
                                                                v-if="needsAction(item)"
                                                            >
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-list-item
                                                                        v-if="needsAction(item)"
                                                                        @click.stop="
                                                                            activateActionMenu(
                                                                                $event,
                                                                                item,
                                                                            )
                                                                        "
                                                                        :id="
                                                                            'more-actions-' +
                                                                            index +
                                                                            '-' +
                                                                            alIndex
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Plus d'actions
                                                                        </v-list-item-title>
                                                                        <template #append>
                                                                            <v-icon size="x-small"
                                                                                >$dots_vertical</v-icon
                                                                            >
                                                                        </template>
                                                                    </v-list-item>
                                                                </template>
                                                                <v-list density="compact">
                                                                    <v-list-item
                                                                        v-if="
                                                                            getToReconciliateBTWithDocuments(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            documentPanel =
                                                                                !documentPanel;
                                                                            suggestedDocumentPanel = false;
                                                                            bankTransactionPanel = false;
                                                                            reconciliationPanel = false;
                                                                        "
                                                                    >
                                                                        <template #append>
                                                                            <v-icon size="x-small"
                                                                                >$fa-search</v-icon
                                                                            >
                                                                        </template>
                                                                        <v-list-item-title
                                                                            >Chercher un
                                                                            justificatif</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <!-- <v-list-item v-if="getToReconciliateBTWithDocuments(selectedGroup)" @click.stop="selectedGroup = selectedGroup; documentPanel = false; suggestedDocumentPanel = false; bankTransactionPanel=!bankTransactionPanel; reconciliationPanel=false;">
                    <template>
                        <v-list-item-title>Chercher un mouvement bancaire</v-list-item-title>
                    </template>
                    <v-list-item-icon>
                        <v-icon  size=“x-small”>$fa-search</v-icon>
                    </v-list-item-icon>
                </v-list-item> -->
                                                                    <v-list-item
                                                                        v-if="
                                                                            showSuggestedDocuments(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            suggestedDocumentPanel =
                                                                                !suggestedDocumentPanel;
                                                                            documentPanel = false;
                                                                            bankTransactionPanel = false;
                                                                            reconciliationPanel = false;
                                                                        "
                                                                    >
                                                                        <template #append>
                                                                            <v-icon size="x-small"
                                                                                >$fa-magic</v-icon
                                                                            >
                                                                        </template>
                                                                        <v-list-item-title
                                                                            >Justificatifs
                                                                            suggérés</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            getWithoutInvoiceBT(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showWithoutInvoiceDialog =
                                                                                !showWithoutInvoiceDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Justificatif
                                                                            manquant</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showIOPBTDialog =
                                                                                !showIOPBTDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Lier un
                                                                            document</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            showAutoSalesReconciliation(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            autoSalesReconciliation =
                                                                                !autoSalesReconciliation;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Encaissement</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <!-- <v-list-item v-if="getWithDeltaBT(selectedGroup)" @click.stop="selectedGroup = selectedGroup; validationWithDelta = !validationWithDelta">
                    <template>
                        <v-list-item-title>Solder</v-list-item-title>
                    </template>
                </v-list-item> -->
                                                                    <v-divider
                                                                        v-if="
                                                                            getToReconciliateBTWithDocuments(
                                                                                selectedGroup,
                                                                            ) ||
                                                                            showSuggestedDocuments(
                                                                                selectedGroup,
                                                                            ) ||
                                                                            getWithoutInvoiceBT(
                                                                                selectedGroup,
                                                                            ) ||
                                                                            showAutoSalesReconciliation(
                                                                                selectedGroup,
                                                                            ) ||
                                                                            getWithDeltaBT(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                    />
                                                                    <v-list-item
                                                                        v-if="cashPaymentDocItem"
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showCashPaymentDialog =
                                                                                !showCashPaymentDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Réglée en
                                                                            espèce</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="cashPaymentDocItem"
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showRemittanceDialog =
                                                                                !showRemittanceDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Chèque|Vir.|Prél. non
                                                                            encaissé</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="cashWithdrawalBTItem"
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showCashWithdrawalDialog =
                                                                                !showCashWithdrawalDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Retrait en
                                                                            espèce</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            getZTillBT(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showZTillDialog =
                                                                                !showZTillDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Réglement du Z de
                                                                            caisse</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-divider
                                                                        v-if="
                                                                            cashPaymentDocItem ||
                                                                            cashWithdrawalBTItem ||
                                                                            getZTillBT(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                    />
                                                                    <v-list-item
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            companyType =
                                                                                'SUPPLIER';
                                                                            showThirdPartyCompanyDialog =
                                                                                !showThirdPartyCompanyDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Règlement
                                                                            fournisseur</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            companyType =
                                                                                'CUSTOMER';
                                                                            showThirdPartyCompanyDialog =
                                                                                !showThirdPartyCompanyDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Règlement
                                                                            client</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <accountable-account
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        :title="
                                                                            subAccountableAccountTitle
                                                                        "
                                                                        :defineThirdParty="true"
                                                                        :showLabel="true"
                                                                        :showValidation="false"
                                                                        :companyId="
                                                                            selectedCompany.id
                                                                        "
                                                                        inAccountableAccountType="Selected"
                                                                        :embeddedInput="true"
                                                                        :editAccountableAccount="
                                                                            true
                                                                        "
                                                                        :inAccountableAccountNames="
                                                                            subSelectedAccountableAccounts
                                                                        "
                                                                        :activateFreeTag="true"
                                                                        @close="
                                                                            closeAccountableAccount
                                                                        "
                                                                        @select-accountableAccount="
                                                                            setAccountableAccount(
                                                                                $event,
                                                                            )
                                                                        "
                                                                    >
                                                                        <template
                                                                            v-slot:activator="{
                                                                                props,
                                                                            }"
                                                                        >
                                                                            <v-list-item
                                                                                v-bind="props"
                                                                                v-if="
                                                                                    getThirdPartyCompanyBTItem(
                                                                                        selectedGroup,
                                                                                    )
                                                                                "
                                                                                @click.stop="
                                                                                    socialAccountableAccount(
                                                                                        selectedGroup,
                                                                                    )
                                                                                "
                                                                            >
                                                                                <v-list-item-title
                                                                                    >Règlement
                                                                                    social</v-list-item-title
                                                                                ></v-list-item
                                                                            >
                                                                        </template>
                                                                    </accountable-account>
                                                                    <accountable-account
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        :title="
                                                                            subAccountableAccountTitle
                                                                        "
                                                                        :defineThirdParty="true"
                                                                        :showLabel="true"
                                                                        :showValidation="false"
                                                                        :companyId="
                                                                            selectedCompany.id
                                                                        "
                                                                        inAccountableAccountType="Selected"
                                                                        :embeddedInput="true"
                                                                        :editAccountableAccount="
                                                                            true
                                                                        "
                                                                        :inAccountableAccountNames="
                                                                            subSelectedAccountableAccounts
                                                                        "
                                                                        :activateFreeTag="true"
                                                                        @close="
                                                                            closeAccountableAccount
                                                                        "
                                                                        @select-accountableAccount="
                                                                            setAccountableAccount(
                                                                                $event,
                                                                            )
                                                                        "
                                                                    >
                                                                        <template
                                                                            v-slot:activator="{
                                                                                props,
                                                                            }"
                                                                        >
                                                                            <v-list-item
                                                                                v-bind="props"
                                                                                v-if="
                                                                                    getThirdPartyCompanyBTItem(
                                                                                        selectedGroup,
                                                                                    )
                                                                                "
                                                                                @click.stop="
                                                                                    stateAccountableAccount(
                                                                                        selectedGroup,
                                                                                    )
                                                                                "
                                                                            >
                                                                                <v-list-item-title
                                                                                    >Règlement
                                                                                    état</v-list-item-title
                                                                                ></v-list-item
                                                                            >
                                                                        </template>
                                                                    </accountable-account>
                                                                    <v-divider
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                    />
                                                                    <accountable-account
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        :title="
                                                                            subAccountableAccountTitle
                                                                        "
                                                                        :defineThirdParty="true"
                                                                        :showLabel="true"
                                                                        :showValidation="false"
                                                                        :companyId="
                                                                            selectedCompany.id
                                                                        "
                                                                        :inAccountableAccountType="'Selected'"
                                                                        :embeddedInput="true"
                                                                        :editAccountableAccount="
                                                                            true
                                                                        "
                                                                        :inAccountableAccountNames="
                                                                            subSelectedAccountableAccounts
                                                                        "
                                                                        :activateFreeTag="true"
                                                                        @close="
                                                                            closeAccountableAccount
                                                                        "
                                                                        @select-accountableAccount="
                                                                            setAccountableAccount(
                                                                                $event,
                                                                            )
                                                                        "
                                                                    >
                                                                        <template
                                                                            v-slot:activator="{
                                                                                props,
                                                                            }"
                                                                        >
                                                                            <v-list-item
                                                                                v-bind="props"
                                                                                v-if="
                                                                                    getThirdPartyCompanyBTItem(
                                                                                        selectedGroup,
                                                                                    )
                                                                                "
                                                                                @click.stop="
                                                                                    miscelleanousAccountableAccount(
                                                                                        selectedGroup,
                                                                                    )
                                                                                "
                                                                            >
                                                                                <v-list-item-title
                                                                                    >Tous les
                                                                                    comptes</v-list-item-title
                                                                                ></v-list-item
                                                                            >
                                                                        </template>
                                                                    </accountable-account>
                                                                    <v-divider
                                                                        v-if="
                                                                            getThirdPartyCompanyBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                    />
                                                                    <v-list-item
                                                                        v-if="
                                                                            getCurrentAccountBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            currentAccountAccountableAccount =
                                                                                getDefaultCurrentAccount();
                                                                            showLinkWithCurrentAccountDialog =
                                                                                !showLinkWithCurrentAccountDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title>{{
                                                                            getCurrentAccountTitle()
                                                                        }}</v-list-item-title></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            getCurrentAccountBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            currentAccountAccountableAccount =
                                                                                '467000';
                                                                            showLinkWithCurrentAccountDialog =
                                                                                !showLinkWithCurrentAccountDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title>{{
                                                                            $t(
                                                                                "reconciliation.action.DEBIT_CREDIT_ACCOUNT",
                                                                            )
                                                                        }}</v-list-item-title></v-list-item
                                                                    >
                                                                    <v-divider
                                                                        v-if="
                                                                            getCurrentAccountBTItem(
                                                                                selectedGroup,
                                                                            ) ||
                                                                            getCurrentAccountBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                    />
                                                                    <v-list-item
                                                                        v-if="
                                                                            getCommissionBTItem(
                                                                                selectedGroup,
                                                                            )
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showAddCommissionDialog =
                                                                                !showAddCommissionDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Commission</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            getLoanBT(selectedGroup)
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showAddLoanDialog =
                                                                                !showAddLoanDialog;
                                                                        "
                                                                    >
                                                                        <v-list-item-title>{{
                                                                            getLoanBT(selectedGroup)
                                                                                .bt.amount > 0
                                                                                ? "Versement du prêt"
                                                                                : "Remboursement emprunt"
                                                                        }}</v-list-item-title></v-list-item
                                                                    >
                                                                    <v-divider
                                                                        v-if="
                                                                            getCommissionBTItem(
                                                                                selectedGroup,
                                                                            ) ||
                                                                            getLoanBT(selectedGroup)
                                                                        "
                                                                    />
                                                                    <v-list-item
                                                                        v-if="
                                                                            getLoanBT(selectedGroup)
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showCutAccountingLineDialog =
                                                                                !showCutAccountingLineDialog;
                                                                        "
                                                                    >
                                                                        <template #append>
                                                                            <v-icon size="x-small"
                                                                                >$fa-cut</v-icon
                                                                            >
                                                                        </template>
                                                                        <v-list-item-title
                                                                            >Découper</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                    <v-list-item
                                                                        v-if="
                                                                            getLoanBT(selectedGroup)
                                                                        "
                                                                        @click.stop="
                                                                            selectedGroup =
                                                                                selectedGroup;
                                                                            showAccountingItemDialog =
                                                                                !showAccountingItemDialog;
                                                                        "
                                                                    >
                                                                        <template #append>
                                                                            <v-icon size="x-small"
                                                                                >$oss-edit</v-icon
                                                                            >
                                                                        </template>
                                                                        <v-list-item-title
                                                                            >Editer</v-list-item-title
                                                                        ></v-list-item
                                                                    >
                                                                </v-list>
                                                            </v-menu>
                                                            <!-- <v-list-item><strong></strong></v-list-item> -->
                                                            <v-list-item
                                                                v-if="
                                                                    containsDocumentToValidate(item)
                                                                "
                                                                @click.stop="
                                                                    currentItem = item;
                                                                    addRemoveReconciliationExpend(
                                                                        containsDocumentToValidate(
                                                                            item,
                                                                        ),
                                                                    );
                                                                "
                                                            >
                                                                <v-list-item-title
                                                                    >Valider le
                                                                    document</v-list-item-title
                                                                >
                                                                <template #append>
                                                                    <v-icon size="x-small"
                                                                        >$fa-thumbs-up</v-icon
                                                                    >
                                                                </template>
                                                            </v-list-item>
                                                            <v-list-item
                                                                v-else-if="accountingItem.doc"
                                                                @click.stop="
                                                                    addRemoveReconciliationExpend(
                                                                        accountingItem,
                                                                    )
                                                                "
                                                            >
                                                                <v-list-item-title
                                                                    >Afficher le
                                                                    document</v-list-item-title
                                                                >
                                                                <template #append>
                                                                    <v-icon size="x-small"
                                                                        >$fa-eye</v-icon
                                                                    >
                                                                </template>
                                                            </v-list-item>
                                                            <template v-if="alIndex === 0">
                                                                <v-list-item
                                                                    v-if="
                                                                        !containsDocumentToValidate(
                                                                            item,
                                                                        ) &&
                                                                        showValidateReconciliation(
                                                                            item,
                                                                        )
                                                                    "
                                                                    @click.stop="
                                                                        validateReconciliation(item)
                                                                    "
                                                                    :loading="actionLoading"
                                                                >
                                                                    <v-list-item-title
                                                                        >Valider le lettrage{{
                                                                            getReconciliationValidationType(
                                                                                item,
                                                                            ) ===
                                                                            "PENDING_VALIDATION_FROM_CLIENT"
                                                                                ? " client"
                                                                                : ""
                                                                        }}
                                                                        auto</v-list-item-title
                                                                    >
                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-thumbs-up</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    v-if="
                                                                        !containsDocumentToValidate(
                                                                            item,
                                                                        ) &&
                                                                        showValidateReconciliation(
                                                                            item,
                                                                        )
                                                                    "
                                                                    @click.stop="
                                                                        deleteReconciliation(item)
                                                                    "
                                                                    :loading="actionLoading"
                                                                >
                                                                    <v-list-item-title
                                                                        >Refuser le lettrage{{
                                                                            getReconciliationValidationType(
                                                                                item,
                                                                            ) ===
                                                                            "PENDING_VALIDATION_FROM_CLIENT"
                                                                                ? " client "
                                                                                : ""
                                                                        }}
                                                                        auto</v-list-item-title
                                                                    >

                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-thumbs-down</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    v-else-if="
                                                                        showRemoveCashbox(item)
                                                                    "
                                                                    @click.stop="
                                                                        removeCashbox(item)
                                                                    "
                                                                    :loading="actionLoading"
                                                                >
                                                                    <v-list-item-title
                                                                        >Retirer de la
                                                                        caisse</v-list-item-title
                                                                    >

                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-trash-alt</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    v-else-if="
                                                                        showRemoveRemittance(item)
                                                                    "
                                                                    @click.stop="
                                                                        deleteReconciliation(item)
                                                                    "
                                                                    :loading="actionLoading"
                                                                >
                                                                    <v-list-item-title
                                                                        >Retirer du paiement par
                                                                        chèque</v-list-item-title
                                                                    >

                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-trash-alt</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    v-else-if="
                                                                        showRemoveCurrentAccount(
                                                                            item,
                                                                        )
                                                                    "
                                                                    @click.stop="
                                                                        removeCurrentAccount(item)
                                                                    "
                                                                >
                                                                    <v-list-item-title>{{
                                                                        removeCurrentAccountTitle
                                                                    }}</v-list-item-title>

                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-trash-alt</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    v-else-if="
                                                                        showDeleteReconciliation(
                                                                            item,
                                                                        )
                                                                    "
                                                                    @click.stop="
                                                                        deleteReconciliation(item)
                                                                    "
                                                                >
                                                                    <v-list-item-title
                                                                        >Supprimer le
                                                                        lettrage</v-list-item-title
                                                                    >

                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-trash-alt</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    v-else-if="
                                                                        showGroupNotReconciliatedAndWithImputation(
                                                                            item,
                                                                        ) &&
                                                                        enableRemoveImputation(item)
                                                                    "
                                                                    @click.stop="
                                                                        removeImputation(item)
                                                                    "
                                                                >
                                                                    <v-list-item-title>{{
                                                                        removeImputationTitle(item)
                                                                    }}</v-list-item-title>

                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-trash-alt</v-icon
                                                                        >
                                                                    </template>
                                                                </v-list-item>
                                                                <!-- <v-list-item
                                                                    v-if="
                                                                        enableShowGeneralLedger(
                                                                            item,
                                                                        )
                                                                    "
                                                                    @click.stop="
                                                                        showGeneralLedger(item)
                                                                    "
                                                                >
                                                                    <v-list-item-title
                                                                        >Ecritures</v-list-item-title
                                                                    >

                                                                    <template #append>
                                                                        <v-icon
                                                                            size="x-small"
                                                                            icon="$fa-chevron-right"
                                                                        >
                                                                        </v-icon>
                                                                    </template>
                                                                </v-list-item> -->
                                                                <v-list-item
                                                                    v-if="accountingItem.doc"
                                                                    @click.stop="
                                                                        deallocateBankTransactions()
                                                                    "
                                                                >
                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-trash-alt</v-icon
                                                                        >
                                                                    </template>
                                                                    <v-list-item-title
                                                                        >Retirer
                                                                        l'affectation</v-list-item-title
                                                                    ></v-list-item
                                                                >
                                                                <v-list-item
                                                                    v-if="enableFixedAssets(item)"
                                                                    @click.stop="
                                                                        openFixedAssets(item)
                                                                    "
                                                                >
                                                                    <template #append>
                                                                        <v-icon size="x-small"
                                                                            >$fa-chevron-right</v-icon
                                                                        >
                                                                    </template>
                                                                    <v-list-item-title
                                                                        >Amos</v-list-item-title
                                                                    ></v-list-item
                                                                >
                                                            </template>
                                                        </v-list>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-slot:body.append>
                                                <tr>
                                                    <td
                                                        colspan="7"
                                                        :style="getCellStyle(0, false)"
                                                    />
                                                    <td
                                                        v-if="
                                                            selectedCompany.solution !==
                                                                'MANAGEMENT' &&
                                                            mode != 'GeneralLedger'
                                                        "
                                                        class="d-flex align-center justify-center"
                                                        :style="getCellStyle(0, false)"
                                                    >
                                                        <v-tooltip location="top">
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn
                                                                    rounded="circle"
                                                                    elevation="0"
                                                                    class="mr-2"
                                                                    @click.stop="
                                                                        setOpenChat(
                                                                            'INFORMATION_REQUEST',
                                                                        )
                                                                    "
                                                                    v-if="
                                                                        !reconciliation ||
                                                                        !reconciliation.id
                                                                    "
                                                                    size="x-small"
                                                                    v-bind="props"
                                                                    icon="$oss-chat"
                                                                >
                                                                </v-btn>
                                                            </template>
                                                            <span>Question</span>
                                                        </v-tooltip>
                                                        <v-tooltip location="top">
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn-prev
                                                                    :disabled="previousDisabled()"
                                                                    @click.stop="previous()"
                                                                    v-bind="props"
                                                                >
                                                                </v-btn-prev>
                                                            </template>
                                                            <span>Précédent</span>
                                                        </v-tooltip>

                                                        <v-btn-icon
                                                            icon="$stop"
                                                            elevation="0"
                                                            color="secondary"
                                                            @click.stop="back()"
                                                            v-if="toBeDoneStatus"
                                                            size="small"
                                                        />
                                                        <v-tooltip location="top">
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn-next
                                                                    :disabled="nextDisabled()"
                                                                    @click.stop="next()"
                                                                    v-if="mode != 'GeneralLedger'"
                                                                    v-bind="props"
                                                                >
                                                                </v-btn-next>
                                                            </template>
                                                            <span>Suivant</span>
                                                        </v-tooltip>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>

                            <v-slide-y-transition>
                                <div>
                                    <v-card-text v-show="suggestedDocumentPanel">
                                        <v-container fluid>
                                            <v-data-table
                                                :headers="suggestedDocumentHeaders"
                                                :items="suggestedDocuments"
                                                v-model:expanded="suggestedDocumentExpanded"
                                                :items-per-page-options="[5, 10, 25]"
                                                class="table"
                                                fixed-header
                                                max-height="60vh"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="text-center"
                                                            @click.stop="
                                                                addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            "
                                                        >
                                                            {{ props.item.name }}
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                            @click.stop="
                                                                addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            "
                                                        >
                                                            {{ props.item.date }}
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                            @click.stop="
                                                                addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                props.item.debit
                                                                    ? newCommonFormatCurrency(
                                                                          props.item.debit,
                                                                      )
                                                                    : "-"
                                                            }}
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                            @click.stop="
                                                                addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                props.item.credit
                                                                    ? newCommonFormatCurrency(
                                                                          props.item.credit,
                                                                      )
                                                                    : "-"
                                                            }}
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                            @click.stop="
                                                                replaceBySuggestedDocument(
                                                                    props.item,
                                                                )
                                                            "
                                                        >
                                                            <v-btn rounded dense color="primary"
                                                                >Remplacer</v-btn
                                                            >
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:expanded-row="{ columns, item }">
                                                    <td :colspan="columns.length">
                                                        <v-row
                                                            align="center"
                                                            justify="center"
                                                            v-if="item.signedUrl"
                                                        >
                                                            <v-img
                                                                :src="item.signedUrl"
                                                                lazy-src="../assets/logo.png"
                                                                width="60vw"
                                                                :contain="true"
                                                                class="elevation-5 ma-4"
                                                            />
                                                        </v-row>
                                                    </td>
                                                </template>
                                            </v-data-table>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-text v-show="documentPanel">
                                        <DocumentReconciliator
                                            v-if="documentPanel"
                                            :itemReconciliations="itemReconciliations"
                                            :reconciliationItems="reconciliationItems"
                                            :companyId="companyId"
                                            :documentType="reconciliatorDocumentType"
                                            :amountSigned="bankTransactionAmount"
                                            @addAccountingLine="addAccountingLine($event)"
                                        />
                                    </v-card-text>
                                    <v-card-text row xs12 wrap v-show="bankTransactionPanel">
                                        <v-container fluid>
                                            <v-layout
                                                align-center
                                                class="filter-layout pa-2"
                                                id="documents-btFilter-box"
                                            >
                                                <v-flex xs2 px-1>
                                                    <v-text-field
                                                        outlined
                                                        append-inner-icon="$euro"
                                                        v-model="btFilter.amount.minimum"
                                                        label="Min"
                                                        class="amount-filter margin"
                                                        type="number"
                                                        :hide-details="true"
                                                        density="compact"
                                                    />
                                                </v-flex>
                                                <v-flex xs2 px-1>
                                                    <v-text-field
                                                        outlined
                                                        append-inner-icon="$euro"
                                                        v-model="btFilter.amount.maximum"
                                                        label="Max"
                                                        class="amount-filter margin"
                                                        type="number"
                                                        :hide-details="true"
                                                        density="compact"
                                                    />
                                                </v-flex>
                                                <v-flex xs4 px-1>
                                                    <oss-date-range-picker
                                                        :begin="btFilter.date.begin"
                                                        :end="btFilter.date.end"
                                                        :dense="true"
                                                        @change-dateRange="onBTDateRangeChanged"
                                                        :hide-details="true"
                                                    >
                                                    </oss-date-range-picker>
                                                </v-flex>
                                                <v-flex xs3 px-1>
                                                    <v-text-field
                                                        outlined
                                                        v-model="btFilter.search"
                                                        append-inner-icon="$search"
                                                        label="Recherche"
                                                        :hide-details="true"
                                                        density="compact"
                                                    />
                                                </v-flex>
                                                <v-flex px-1>
                                                    <v-btn
                                                        rounded="circle"
                                                        class="elevation-0"
                                                        :disabled="
                                                            isFiltered(defaultBTFilter, btFilter)
                                                        "
                                                        @click.stop="clearBTFilters()"
                                                        size="small"
                                                        icon="$clear"
                                                    >
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>

                                        <v-container fuild>
                                            <v-data-table-server
                                                :headers="selectionHeaders"
                                                :items="availableBankTransactions"
                                                v-model:page="btFilter.pagination.page"
                                                v-model:sort-by="btFilter.pagination.sortBy"
                                                v-model:items-per-page="
                                                    btFilter.pagination.rowsPerPage
                                                "
                                                :items-length="btFilter.pagination.totalItems"
                                                :items-per-page-options="[5, 10, 25]"
                                                class="table"
                                                fixed-header
                                                max-height="60vh"
                                            >
                                                <template v-slot:no-data>
                                                    <v-alert
                                                        color="error"
                                                        icon="warning"
                                                        :model-value="true"
                                                        >no item</v-alert
                                                    >
                                                </template>
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td class="text-center">
                                                            <div>{{ props.item.name }}</div>
                                                            <div v-if="props.item.suppliers">
                                                                Fournisseur:
                                                                {{ props.item.suppliers }}
                                                            </div>
                                                            <div v-if="props.item.customers">
                                                                Client: {{ props.item.customers }}
                                                            </div>
                                                            <div v-if="props.item.user">
                                                                Collaborateur :
                                                                {{ props.item.user }}
                                                            </div>
                                                            <div v-if="props.item.bankAccount">
                                                                Compte bancaire :
                                                                {{ props.item.bankAccount }}
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            {{ props.item.date }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                props.item.debit
                                                                    ? newCommonFormatCurrency(
                                                                          props.item.debit,
                                                                      )
                                                                    : "-"
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                props.item.credit
                                                                    ? newCommonFormatCurrency(
                                                                          props.item.credit,
                                                                      )
                                                                    : "-"
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table-server>
                                        </v-container>
                                    </v-card-text>
                                </div>
                            </v-slide-y-transition>
                        </v-window-item>
                        <v-window-item :value="1">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <!-- <AccountableAccountBalanceDetail
                                        :companyId="companyId"
                                        :accountingPeriodId="''"
                                        :accountableAccountInfo="accountableAccountInfo"
                                        :selectedAccountingLineId="selectedAccountingLineId"
                                        :notReconciliated="withoutLettering"
                                        :withoutBank="withoutBank"
                                        :withoutDocument="withoutDocument"
                                        v-if="accountableAccountInfo"
                                        @refresh="refresh()"
                                    >
                                    </AccountableAccountBalanceDetail> -->
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
            <!-- <div class="text-center" v-if="mode!='GeneralLedger'" v-show="wizardStep===0"> -->
            <!-- <div class="bottom-sheet"> -->
            <!-- <div class="remote" style="pointer-events: auto;"> -->
            <!-- <v-container class="controller" elevation-1> -->
            <!-- <b>Action : </b>{{ advice }} -->
            <!-- <v-btn
                                class="btn"
                                rounded="circle"
                                 size=“x-small”
                                elevation="0"
                                color="primary"
                                :disabled="previousDisabled()"
                                @click.stop="previous()"
                            >
                                <v-icon>$navigate_before</v-icon>
                            </v-btn>
                            <v-btn
                                class="btn"
                                rounded="circle"
                                 size=“x-small”
                                elevation="0"
                                color="primary"
                                @click.stop="back()"
                                v-if="toBeDoneStatus"
                            >
                                <v-icon>$stop</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="nextDisabled()"
                                class="btn"
                                rounded="circle"
                                 size=“x-small”
                                elevation="0"
                                color="primary"
                                @click.stop="next()"
                            >
                                <v-icon>$navigate_next</v-icon>
                            </v-btn> -->
            <!-- <v-btn
                                class="btn"
                                rounded
                                 size="small"
                                color="primary"
                                @click.stop="setOpenChat('INFORMATION_REQUEST')"
                                v-if="!reconciliation || !reconciliation.id"
                            >
                                <v-icon>$fa-comments</v-icon>
                                <span>Question</span>
                            </v-btn> -->
            <!-- </v-container> -->
            <!-- </div> -->
            <!-- </div> -->
            <!-- </div> -->
        </template>
        <!-- Embedded -->
        <template v-else>
            <v-row no-gutters class="pa-1" v-if="$vuetify.display.mobile">
                <v-col cols="12" class="d-flex flex-row pa-2">
                    <div class="mr-2">
                        <v-btn-back @click.stop="back()" v-if="mode != 'GeneralLedger'">
                        </v-btn-back>
                    </div>
                    <div>
                        <h1>{{ title }}</h1>
                    </div>
                    <!-- <div>
                        <v-btn-icon
                            @click.stop="help()"
                            class="ml-3"
                            size="small"
                            icon="$fa-question"
                        >
                        </v-btn-icon>
                    </div> -->
                </v-col>
            </v-row>
            <v-card class="default_card large elevation-0 fill-height pa-2 my-0">
                <v-row no-gutters v-for="(group, index) of groupedAccountingLines" :key="index">
                    <v-col cols="10" class="font-weight-bold d-flex align-center header my-2 pl-2">
                        {{ groupStatus(group) }}
                    </v-col>
                    <v-col cols="2" class="d-flex align-center justify-end mb-2">
                        <v-menu v-if="needsAction(group)">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon icon="$dots_vertical" v-bind="props" />
                            </template>
                            <v-list density="compact">
                                <v-list-item
                                    v-if="getToReconciliateBTWithDocuments(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        documentPanel = !documentPanel;
                                        suggestedDocumentPanel = false;
                                        bankTransactionPanel = false;
                                        reconciliationPanel = false;
                                    "
                                >
                                    <template #append>
                                        <v-icon size="x-small">$fa-search</v-icon>
                                    </template>
                                    <v-list-item-title
                                        >Chercher un justificatif</v-list-item-title
                                    ></v-list-item
                                >
                                <v-list-item
                                    v-if="showSuggestedDocuments(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        suggestedDocumentPanel = !suggestedDocumentPanel;
                                        documentPanel = false;
                                        bankTransactionPanel = false;
                                        reconciliationPanel = false;
                                    "
                                >
                                    <template #append>
                                        <v-icon size="x-small">$fa-magic</v-icon>
                                    </template>
                                    <v-list-item-title
                                        >Justificatifs suggérés</v-list-item-title
                                    ></v-list-item
                                >
                                <v-list-item
                                    v-if="getWithoutInvoiceBT(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        showWithoutInvoiceDialog = !showWithoutInvoiceDialog;
                                    "
                                >
                                    <v-list-item-title
                                        >Autre opération</v-list-item-title
                                    ></v-list-item
                                >
                                <!-- <v-list-item v-if="showAutoSalesReconciliation(group)" @click.stop="selectedGroup = group; autoSalesReconciliation = !autoSalesReconciliation">
                                    <template>
                                        <v-list-item-title>Encaissement</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <!-- <v-list-item v-if="getWithDeltaBT(group)" @click.stop="selectedGroup = group; validationWithDelta = !validationWithDelta">
                                    <template>
                                        <v-list-item-title>Solder</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <!-- <v-divider v-if="getToReconciliateBTWithDocuments(group) || showSuggestedDocuments(group) || getWithoutInvoiceBT(group) || showAutoSalesReconciliation(group) || getWithDeltaBT(group)"></v-divider> -->
                                <!-- <v-list-item v-if="cashPaymentDocItem" @click.stop="selectedGroup = group; showCashPaymentDialog = !showCashPaymentDialog">
                                    <template>
                                        <v-list-item-title>Facture réglée en espèce</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <!-- <v-list-item v-if="cashWithdrawalBTItem" @click.stop="selectedGroup = group; showCashWithdrawalDialog = !showCashWithdrawalDialog">
                                    <template>
                                        <v-list-item-title>Retrait en espèce</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <!-- <v-list-item v-if="getZTillBT(group)" @click.stop="selectedGroup = group; showZTillDialog = !showZTillDialog">
                                    <template>
                                        <v-list-item-title>Réglement du Z de caisse</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <v-divider
                                    v-if="
                                        cashPaymentDocItem ||
                                        cashWithdrawalBTItem ||
                                        getZTillBT(group)
                                    "
                                />
                                <v-list-item
                                    v-if="getThirdPartyCompanyBTItem(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        companyType = 'SUPPLIER';
                                        showThirdPartyCompanyDialog = !showThirdPartyCompanyDialog;
                                    "
                                >
                                    <v-list-item-title
                                        >Règlement fournisseur</v-list-item-title
                                    ></v-list-item
                                >
                                <v-list-item
                                    v-if="getThirdPartyCompanyBTItem(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        companyType = 'CUSTOMER';
                                        showThirdPartyCompanyDialog = !showThirdPartyCompanyDialog;
                                    "
                                >
                                    <v-list-item-title
                                        >Règlement client</v-list-item-title
                                    ></v-list-item
                                >
                                <v-divider v-if="getThirdPartyCompanyBTItem(group)" />
                                <v-list-item
                                    v-if="getThirdPartyCompanyBTItem(group)"
                                    @click.stop="socialAccountableAccount(group)"
                                >
                                    <v-list-item-title
                                        >Règlement social</v-list-item-title
                                    ></v-list-item
                                >
                                <v-list-item
                                    v-if="getThirdPartyCompanyBTItem(group)"
                                    @click.stop="stateAccountableAccount(group)"
                                >
                                    <v-list-item-title
                                        >Règlement état</v-list-item-title
                                    ></v-list-item
                                >
                                <!-- <v-list-item v-if="getThirdPartyCompanyBTItem(group)" @click.stop="miscelleanousAccountableAccount(group)">
                                    <template>
                                        <v-list-item-title>Règlement divers</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <!-- <v-divider v-if="getThirdPartyCompanyBTItem(group)"></v-divider> -->
                                <!-- <v-list-item v-if="getCurrentAccountBTItem(group)" @click.stop="selectedGroup = group; currentAccountAccountableAccount=getDefaultCurrentAccount();showLinkWithCurrentAccountDialog = !showLinkWithCurrentAccountDialog">
                                    <template>
                                        <v-list-item-title>{{getCurrentAccountTitle()}}</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <!-- <v-list-item v-if="getCurrentAccountBTItem(group)" @click.stop="selectedGroup = group; currentAccountAccountableAccount='467000';showLinkWithCurrentAccountDialog = !showLinkWithCurrentAccountDialog">
                                    <template>
                                        <v-list-item-title>{{$t("reconciliation.action.DEBIT_CREDIT_ACCOUNT")}}</v-list-item-title>
                                    </template>
                                </v-list-item> -->
                                <v-divider
                                    v-if="
                                        getCurrentAccountBTItem(group) ||
                                        getCurrentAccountBTItem(group)
                                    "
                                />
                                <v-list-item
                                    v-if="getCommissionBTItem(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        showAddCommissionDialog = !showAddCommissionDialog;
                                    "
                                >
                                    <v-list-item-title>Commission</v-list-item-title></v-list-item
                                >
                                <v-list-item
                                    v-if="getLoanBT(group)"
                                    @click.stop="
                                        selectedGroup = group;
                                        showAddLoanDialog = !showAddLoanDialog;
                                    "
                                >
                                    <v-list-item-title>{{
                                        getLoanBT(group).bt.amount > 0
                                            ? "Versement du prêt"
                                            : "Remboursement emprunt"
                                    }}</v-list-item-title></v-list-item
                                >
                                <!-- <v-divider v-if="getCommissionBTItem(group) || getLoanBT(group)"></v-divider> -->
                                <!-- <v-list-item v-if="getLoanBT(group)" @click.stop="selectedGroup = group; showCutAccountingLineDialog = !showCutAccountingLineDialog">
                                    <template>
                                        <v-list-item-title>Découper</v-list-item-title>
                                    </template>
                                    <v-list-item-icon>
                                        <v-icon  size=“x-small”>$fa-cut</v-icon>
                                    </v-list-item-icon>
                                </v-list-item> -->
                            </v-list>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" v-for="(item, index) in group.items" :key="index">
                        <v-card
                            class="default_card_wm mx-auto pa-2 mb-2"
                            style="
                                background: #fff !important;
                                border: solid rgba(0, 0, 0, 0.12) 1px;
                                box-shadow: none;
                            "
                            @click.stop="
                                addRemoveReconciliationExpend(containsDocumentToValidate(group))
                            "
                        >
                            <v-row no-gutters>
                                <v-col cols="1" class="d-flex align-center justify-center">
                                    <v-icon :small="true" class="mr-2">{{
                                        formatIconName(item.iconType)
                                    }}</v-icon>
                                </v-col>
                                <v-col cols="11">
                                    <div class="d-flex justify-space-between">
                                        <div>
                                            <v-chip
                                                label
                                                color="grey"
                                                class="mr-2"
                                                v-if="
                                                    (item.bt && item.bt.accountingItemImport) ||
                                                    (item.doc && item.doc.accountingItemImport)
                                                "
                                                size="small"
                                                variant="outlined"
                                            >
                                                Importé
                                            </v-chip>
                                            {{ item.name }}
                                        </div>
                                        <v-chip
                                            v-if="item.doc && containsDocumentToValidate(group)"
                                            size="small"
                                            >Document non validé</v-chip
                                        >
                                        <v-icon v-else-if="item.doc" color="secondary" size="small"
                                            >$oss-circle-check</v-icon
                                        >
                                    </div>
                                    <div v-if="item.bt">
                                        <span v-if="item.suppliers"
                                            >Fournisseur: {{ item.suppliers }}</span
                                        >
                                        <span v-if="item.customers"
                                            >Client: {{ item.customers }}</span
                                        >
                                        <span v-if="item.user"
                                            >Collaborateur : {{ item.user }}</span
                                        >
                                    </div>
                                    <div v-if="item.doc">
                                        <!-- <v-chip  size=“x-small” label :ripple="false" v-if="item.doc.status.startsWith('ANALYSED')">
                                            <span :style="'color:orange;'">A valider</span>
                                        </v-chip> -->
                                        <span v-if="item.doc.type === 'WITHOUT_INVOICE'"
                                            >Sans justificatif</span
                                        >
                                        <span v-else-if="item.doc.type === 'SALES_INVOICE_AUTO'"
                                            >Encaissemment</span
                                        >
                                    </div>
                                </v-col>
                                <!-- <v-col cols="3" class="d-flex align-center justify-center">
                                    {{ item.date }}
                                </v-col> -->
                            </v-row>
                            <v-row no-gutters class="mt-3">
                                <v-col cols="4" class="d-flex justify-space-between pr-3">
                                    {{ item.date }}
                                </v-col>
                                <v-col cols="4" class="d-flex justify-end pr-3 font-weight-bold">
                                    <span
                                        >{{
                                            item.debit ? newCommonFormatCurrency(item.debit) : "-"
                                        }}
                                        D</span
                                    >
                                </v-col>
                                <v-col cols="4" class="d-flex justify-end pl-3 font-weight-bold">
                                    <span
                                        >{{
                                            item.credit ? newCommonFormatCurrency(item.credit) : "-"
                                        }}
                                        C</span
                                    >
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="12"
                        class="d-flex mt-3 justify-space-between"
                        v-if="showValidateReconciliation(group)"
                    >
                        <v-btn
                            elevation="0"
                            rounded
                            outlined
                            :disabled="containsDocumentToValidate(group)"
                            size="small"
                            @click.stop="deleteReconciliation(group)"
                        >
                            Refuser le lettrage{{
                                getReconciliationValidationType(group) ===
                                "PENDING_VALIDATION_FROM_CLIENT"
                                    ? " client"
                                    : ""
                            }}
                            <v-icon size="x-small" location="end">$fa-thumbs-down</v-icon>
                        </v-btn>
                        <v-btn
                            elevation="0"
                            rounded
                            :disabled="containsDocumentToValidate(group)"
                            size="small"
                            @click.stop="validateReconciliation(group)"
                        >
                            Valider le lettrage{{
                                getReconciliationValidationType(group) ===
                                "PENDING_VALIDATION_FROM_CLIENT"
                                    ? " client"
                                    : ""
                            }}
                            <v-icon size="x-small" location="end">$fa-thumbs-up</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- <v-row style="position: absolute; bottom: 0px">
                    <v-col cols="12">
                        Test
                    </v-col>
                </v-row> -->
            </v-card>
        </template>
        <Chat
            v-if="openChat"
            :id="chatId"
            :inShowMessage="open_chat"
            :chatTitle="'Ligne bancaire'"
            :chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
        <oss-dialog
            v-model="showWithoutInvoiceDialog"
            :title="'Sans facture'"
            :actions="withoutInvoiceActions"
            width="800px"
        >
            <WithoutInvoice
                :companyId="companyId"
                :btItem="getWithoutInvoiceBT(selectedGroup)"
                :actions="withoutInvoiceActions"
                @added="
                    showWithoutInvoiceDialog = false;
                    refresh();
                "
            >
            </WithoutInvoice>
        </oss-dialog>
        <ThirdPartyCompany
            v-model="showThirdPartyCompanyDialog"
            :companyId="companyId"
            :companyType="companyType"
            :btItem="getThirdPartyCompanyBTItem(selectedGroup)"
            :activateFreeTag="true"
            @added="onThirdPartyCompanyChanged()"
            v-if="selectedGroup && getThirdPartyCompanyBTItem(selectedGroup)"
        >
        </ThirdPartyCompany>
        <!-- <v-dialog
            v-model="validationWithDelta"
            @keydown.esc="validationWithDelta = false"
        >
            <v-card class="default_card pa-2" max-width="40%" style="margin: auto;">
                <WithDelta
                :reconciliationVue="reconciliationVue"
                :btItem="getWithDeltaBT(selectedGroup)"
                @added='validationWithDelta=false'
                @cancel='validationWithDelta=false'
                >
                </WithDelta>
            </v-card>
        </v-dialog> -->
        <oss-dialog
            v-model="autoSalesReconciliation"
            :title="'Encaissement'"
            :actions="autoSalesActions"
            width="800px"
        >
            <AutoSales
                :companyId="companyId"
                :btItem="showAutoSalesReconciliation(selectedGroup)"
                :actions="autoSalesActions"
                @added="
                    autoSalesReconciliation = false;
                    refresh();
                "
            >
            </AutoSales>
        </oss-dialog>
        <oss-dialog
            v-model="showAddCommissionDialog"
            :title="'Commission'"
            :actions="commissionActions"
            v-if="showAddCommissionDialog"
            width="800px"
        >
            <Commission
                :reconciliationVue="reconciliationVue"
                :companyId="companyId"
                :btItem="getCommissionBTItem(selectedGroup)"
                :actions="commissionActions"
                @added="showAddCommissionDialog = false"
            >
            </Commission>
        </oss-dialog>
        <oss-dialog
            v-model="showAddLoanDialog"
            :title="'Emprunt'"
            :actions="loanActions"
            v-if="showAddLoanDialog"
            width="800px"
        >
            <Loan
                :reconciliationVue="reconciliationVue"
                :companyId="companyId"
                :btItem="getLoanBT(selectedGroup)"
                :actions="loanActions"
                @added="showAddLoanDialog = false"
            >
            </Loan>
        </oss-dialog>

        <oss-dialog
            v-model="showCutAccountingLineDialog"
            :title="'Découper'"
            :actions="cutAccountingLineActions"
            v-if="showCutAccountingLineDialog"
            width="800px"
        >
            <CutAccountingLine
                :reconciliationVue="reconciliationVue"
                :companyId="companyId"
                :btItem="getLoanBT(selectedGroup)"
                :actions="cutAccountingLineActions"
                @added="showCutAccountingLineDialog = false"
            >
            </CutAccountingLine>
        </oss-dialog>
        <oss-dialog
            v-model="showAccountingItemDialog"
            :actions="accountingItemActions"
            v-if="showAccountingItemDialog"
            width="90vw"
        >
            <AccountingItemEdition2
                :companyId="companyId"
                :bankTransactionId="getLoanBT(selectedGroup).bt.id"
                :actions="accountingItemActions"
                @upsert="
                    () => {
                        showAccountingItemDialog = false;
                        refresh();
                    }
                "
            />
        </oss-dialog>

        <oss-dialog
            v-model="showZTillDialog"
            :title="'Affecter à la caisse'"
            :actions="zTillActions"
            v-if="showZTillDialog"
            width="800px"
        >
            <ZTill
                :reconciliationVue="reconciliationVue"
                :zTillBT="getZTillBT(selectedGroup)"
                :actions="zTillActions"
                @added="showZTillDialog = false"
            >
            </ZTill>
        </oss-dialog>

        <oss-dialog
            v-model="showLinkWithCurrentAccountDialog"
            :title="
                currentAccountAccountableAccount === '467000'
                    ? $t('reconciliation.action.DEBIT_CREDIT_ACCOUNT')
                    : getCurrentAccountTitle()
            "
            :actions="currentAccountActions"
            v-if="showLinkWithCurrentAccountDialog"
            width="800px"
        >
            <CurrentAccount
                :reconciliationVue="reconciliationVue"
                :accountableAccount="currentAccountAccountableAccount"
                :companyId="companyId"
                :actions="currentAccountActions"
                @added="showLinkWithCurrentAccountDialog = false"
            >
            </CurrentAccount>
        </oss-dialog>

        <oss-dialog
            v-model="showCashPaymentDialog"
            :title="'Règlement en espèce'"
            :actions="cashPaymentActions"
            v-if="showCashPaymentDialog"
            width="800px"
        >
            <CashPayment
                :userId="currentUser.id"
                :companyId="companyId"
                :accountingLine="cashPaymentDocItem.accountingLine"
                :actions="cashPaymentActions"
                @added="onCashPaymentDone()"
            >
            </CashPayment>
        </oss-dialog>
        <oss-dialog
            v-model="showRemittanceDialog"
            :title="'Règlement par chèque non encaissé'"
            :actions="chequePaymentActions"
            v-if="showRemittanceDialog"
            width="800px"
        >
            <Remittance
                :reconciliationVue="reconciliationVue"
                :companyId="companyId"
                :actions="chequePaymentActions"
                @added="onRemittanceDone()"
            >
            </Remittance>
        </oss-dialog>
        <oss-dialog
            v-model="showCashWithdrawalDialog"
            :title="'Retrait en espèce'"
            :actions="cashWithdrawalActions"
            v-if="showCashWithdrawalDialog"
            width="800px"
        >
            <CashWithdrawal
                :reconciliationVue="reconciliationVue"
                :companyId="companyId"
                :actions="cashWithdrawalActions"
                @added="showCashWithdrawalDialog = false"
            >
            </CashWithdrawal>
        </oss-dialog>

        <oss-dialog
            v-model="documentDialog"
            :withoutHeader="true"
            transition="dialog-bottom-transition"
            v-if="documentDialog"
            min-height="95vh"
            min-width="95vw"
        >
            <v-row no-gutters class="d-flex justify-center">
                <v-col cols="12" style="overflow-y: auto">
                    <document
                        :mode="'Reconciliation'"
                        :companyId="selectedCompany.id"
                        :id="selectedDocument.id"
                        :dark-mode="true"
                        @task-ended="onDocumentValidated"
                    />
                </v-col>
            </v-row>
        </oss-dialog>
        <IOPBankTransactionDialog
            v-model="showIOPBTDialog"
            v-if="showIOPBTDialog"
            :selectedBankTransaction="bankTransaction"
            :selectedCompany="selectedCompany"
            @bankTransactionChanged="onBankTransactionChanged()"
        >
        </IOPBankTransactionDialog>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";

import { ReconciliationFullBase } from "./ReconciliationFullBase";
import Loan from "./reconciliation/Loan.vue";
import Commission from "./reconciliation/Commission.vue";
import ZTill from "./reconciliation/ZTill.vue";
import CurrentAccount from "./reconciliation/CurrentAccount.vue";
import WithoutInvoice from "./reconciliation/WithoutInvoice.vue";
import AutoSales from "./reconciliation/AutoSales.vue";
import CashPayment from "./reconciliation/CashPayment.vue";
import Remittance from "./reconciliation/Remittance.vue";
import CashWithdrawal from "./reconciliation/CashWithdrawal.vue";
import ThirdPartyCompany from "./reconciliation/ThirdPartyCompany.vue";
import CutAccountingLine from "./reconciliation/CutAccountingLine.vue";
// import AccountableAccountBalanceDetail from "./AccountableAccountBalanceDetail.vue";
import AccountingItemEdition2 from "././accounting/accountingItem/Edition.vue";
import DocumentReconciliator from "./DocumentReconciliator.vue";
import IOPBankTransactionDialog from "./IOPBankTransactionDialog.vue";
import Chat from "./chat/Chat.vue";
import Document from "./document/DocumentRouter.vue";
import FreeTag from "./tag/FreeTag.vue";

import { updateBankTransactionAccountableAccount } from "../services/bankTransactionServices";
import {
    socialAccountableAccounts,
    stateAccountableAccounts,
} from "../services/accountableAccountServices";
import AccountableAccount from "./AccountableAccount.vue";
import {
    getAccountingPeriodOfDate_fromStore,
    isInsideClosedAccountingPeriod,
} from "../services/accountingPeriods";
import { DialogAction } from "@/services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        Loan,
        Commission,
        ZTill,
        CurrentAccount,
        WithoutInvoice,
        AutoSales,
        CashPayment,
        Remittance,
        CashWithdrawal,
        ThirdPartyCompany,
        CutAccountingLine,
        Chat,
        Document,
        FreeTag,
        AccountableAccount,
        AccountingItemEdition2,
        DocumentReconciliator,
        IOPBankTransactionDialog,
        // AccountableAccountBalanceDetail,
    },
})
export class ReconciliationFull extends ReconciliationFullBase {
    companyType: string = "";
    // reconciliationHeaders = [
    //     // { title: "Selection", value: "", sortable: false, align: "center" },
    //     { title: "Type", value: "type", sortable: false, align: "center" },
    //     { title: "Libellé", value: "name", sortable: false, align: "center" },
    //     { title: "Date", value: "date", sortable: false, align: "center" },
    //     { title: "Débit", value: "debit", sortable: false, align: "center" },
    //     { title: "Crédit", value: "credit", sortable: false, align: "center" },
    //     { title: "Compte", value: "accountableAccount", sortable: false, align: "center" },
    //     { title: "Statut", value: "status", sortable: false, align: "center" },
    //     { title: "Action", value: "action", sortable: false, align: "center" }
    // ];

    reconciliationsHeaders = [
        { title: "Type", value: "type", sortable: false, align: "center" },
        { title: "Name", value: "name", sortable: false, align: "left" },
        { title: "Date", value: "date", sortable: false, align: "center" },
        { title: "Débit", value: "debit", sortable: false, align: "right" },
        { title: "Crédit", value: "credit", sortable: false, align: "right" },
    ];

    selectionHeaders = [
        // { title: "Selection", value: "", sortable: false },
        { title: "Nom", value: "name", sortable: true, align: "left" },
        { title: "Date", value: "date", sortable: true, align: "center" },
        { title: "Débit", value: "debit", sortable: false, align: "right" },
        { title: "Crédit", value: "credit", sortable: false, align: "right" },
        { title: "Action", value: "action", sortable: false, align: "center" },
    ];

    accountableAccountInfo: any = null;
    selectedAccountingLineId: any = "";

    wizardStep = 0;
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    // showActionMenu: boolean = false;
    // xMenuAction = 0;
    // yMenuAction = 0;
    // selectedGroup = null;

    showIOPBTDialog: boolean = false;

    // activateActionMenu(e, group) {
    //     // debugger;
    //     e.preventDefault();
    //     this.showActionMenu = false;
    //     this.xMenuAction = e.clientX;
    //     this.yMenuAction = e.clientY;
    //     this.$nextTick(() => {
    //         this.showActionMenu = true;
    //         this.selectedGroup = group;
    //     });
    // }

    currentAccountAccountableAccount = "";

    get activateTagguing() {
        return true;
    }

    //
    // Social | State
    //

    subSelectedAccountableAccounts = [];

    // subAccountableAccountDialogSelect = false

    subAccountableAccountTitle = "";

    accountingItemActions = {
        action: new DialogAction(),
    };

    /**
     * Append $ to icon name if not already present
     * @param name
     */
    formatIconName(name: string): string {
        if (!name) {
            return "";
        }
        if (name.startsWith("$")) {
            return name;
        }
        return `$${name}`;
    }

    socialAccountableAccount(group) {
        this.selectedGroup = group;
        this.subSelectedAccountableAccounts = socialAccountableAccounts;
        // this.subAccountableAccountDialogSelect = true
        this.subAccountableAccountTitle = "Social";
    }

    stateAccountableAccount(group) {
        this.selectedGroup = group;
        this.subSelectedAccountableAccounts = stateAccountableAccounts;
        // this.subAccountableAccountDialogSelect = true
        this.subAccountableAccountTitle = "Etat";
    }

    miscelleanousAccountableAccount(group) {
        this.selectedGroup = group;
        this.subSelectedAccountableAccounts = null;
        // this.subAccountableAccountDialogSelect = true
        this.subAccountableAccountTitle = "Divers";
    }

    closesubAccountableAccountDialogSelect() {
        // this.subAccountableAccountDialogSelect = false
    }

    onBankTransactionChanged() {
        this.showIOPBTDialog = !this.showIOPBTDialog;
        this.refresh();
    }

    async setAccountableAccount(data) {
        const thirdPartyCompanyBTItem = this.getThirdPartyCompanyBTItem(this.selectedGroup);
        if (
            thirdPartyCompanyBTItem &&
            thirdPartyCompanyBTItem.bt &&
            data &&
            data.accountableAccount &&
            data.accountableAccount.name
        ) {
            await updateBankTransactionAccountableAccount(
                this.$apollo,
                this.$store,
                this.selectedCompany.id,
                [thirdPartyCompanyBTItem.bt],
                data,
                thirdPartyCompanyBTItem.accountingLine,
            );
            await this.refresh();
        }
    }

    get selectedAccountableAccount() {
        const thirdPartyCompanyBTItem = this.getThirdPartyCompanyBTItem(this.selectedGroup);
        if (thirdPartyCompanyBTItem && thirdPartyCompanyBTItem.accountableAccount) {
            return thirdPartyCompanyBTItem.accountableAccount.name;
        }
        return "";
    }
    //
    //
    //

    get reconciliatorDocumentType() {
        const btAl = this.bankTransaction.accountingLines.find((al) =>
            al.accountableAccount.name.startsWith("512"),
        );
        return btAl.amountSigned > 0 ? "SALES_INVOICE" : "PURCHASE_INVOICE";
    }

    showGeneralLedger(group) {
        const item = group.items[0];

        this.accountableAccountInfo = {
            name: item.accountingLine.accountableAccount.name,
        };
        if (item.accountingLine.thirdPartyCompany) {
            this.accountableAccountInfo.thirdPartyCompanyName =
                item.accountingLine.thirdPartyCompany.name;
        }

        if (item.accountingLine.user) {
            this.accountableAccountInfo.user = item.accountingLine.user.id;
        }
        if (item.accountingLine.bankAccount) {
            this.accountableAccountInfo.bankAccountName = item.accountingLine.bankAccount.name;
            this.accountableAccountInfo.bankAccountType = item.accountingLine.bankAccount.type;
        }
        this.selectedAccountingLineId = item.accountingLine.id;

        this.wizardStep = 1;
    }

    enableFixedAssets(item) {
        if (!item?.mainItem?.accountableAccount?.name) {
            return false;
        }
        if (
            item.mainItem.accountableAccount.name.startsWith("20") ||
            item.mainItem.accountableAccount.name.startsWith("21") ||
            item.mainItem.accountableAccount.name.startsWith("22") ||
            item.mainItem.accountableAccount.name.startsWith("23")
        ) {
            if (item.mainItem?.date) {
                const inClosedPeriod = isInsideClosedAccountingPeriod(
                    this.$store,
                    moment(item.mainItem?.date, "DD-MM-YYYY").format(),
                );
                if (!inClosedPeriod) {
                    return true;
                }
            }
        }
        return false;
    }

    openFixedAssets(item) {
        const documentAccountingPeriod = getAccountingPeriodOfDate_fromStore(
            this.$store,
            moment(item.mainItem?.date, "DD-MM-YYYY").format(),
        );
        const alId = item.items.find((i) => i.accountableAccount?.name?.startsWith("2"))
            ?.accountingLine?.id;
        const location: any = {
            // name: "fixed-assets-to-depreciate2",
            name: "fixed-assets-to-depreciate",
            params: {
                companyId: this.companyId,
                accountingPeriodId: documentAccountingPeriod.id,
                acKey: "rIr4hG5NdQWyEnIXvhnYtmmm",
                accountingLineId: alId || undefined,
                // documentId: this.documentId || undefined,
                // bankTransactionId: this.bankTransactionId || undefined,
            },
        };

        this.$router.push(location);
        return;
    }

    help() {
        document.location.href = "http://bit.ly/3buJcvP";
    }

    get bankTransactionAmount() {
        return this.bankTransaction.accountingLines.find((al) =>
            al.accountableAccount.name.startsWith("512"),
        )?.amountSigned;
    }
}

export default toNative(ReconciliationFull);
</script>
